import { bongo3Products } from './bongo3';
import { k3000FrontierProducts } from './k3000-frontier';
import { k2500K2700Bongo03Products } from './k2500-k2700-bongo03';
import { porterShehzoreProducts } from './porter-shehzore';
import { h100Products } from './h100';
import { hdSeriesProducts } from './hd-series';
import { hd120Products } from './hd120';
import { starexProducts } from './starex';
import { mightyExProducts } from './mighty-ex';
import { tragoProducts } from './trago';
import { countyProducts } from './county';
import { kiaTruckProducts } from './kia-truck';
import { glowPlugs } from './glow-plugs';
import { mufflerBands } from './muffler-bands';
import { daewooLampProducts } from './daewoo-lamps';

export interface Product {
  id: number | string;
  name: string;
  partNumber: string;
  description: string;
  price: number;
  category: string;
  vehicleBrand?: string;
  image: string;
  compatibleVehicles?: string[];
  status?: string;
  inStock?: boolean;
  [key: string]: unknown;
}

export const products: Product[] = [
  // ===== KIA K3000 FRONTIER BONGO98 ===== 9개
  ...k3000FrontierProducts,
  // ===== KIA BONGO 3 12-22 ===== 55개
  ...bongo3Products,
  // ===== KIA K2500 K2700 BONGO 03 ===== 8개
  ...k2500K2700Bongo03Products,
  // ===== KIA TRUCK ===== KIA 시리즈 9개
  ...kiaTruckProducts,
  // ===== HYUNDAI PORTER SHEHZORE 99 PICK UP ===== 10개
  ...porterShehzoreProducts,
  // ===== HYUNDAI H100 ===== 33개
  ...h100Products,
  // ===== HYUNDAI HD35,45,65,72,78 ===== 80개
  ...hdSeriesProducts,
  // ===== HYUNDAI HD120 ===== MIG + VAN 시리즈
  ...hd120Products,
  // ===== HYUNDAI STAREX ===== STA 시리즈 25개
  ...starexProducts,
  // ===== HYUNDAI MIGHTY EX ===== HDM 시리즈 9개
  ...mightyExProducts,
  // ===== HYUNDAI TRAGO HD170-1000 HD-260 ===== HDB 시리즈 41개
  ...tragoProducts,
  // ===== HYUNDAI COUNTY ===== COU 시리즈 14개
  ...countyProducts,
  // ===== GLOW PLUG (글로우 플러그) ===== GLO 시리즈 10개
  ...glowPlugs,
  // ===== 트럭용 소음기 반도/벤딩 ===== MUF 시리즈 4개
  ...mufflerBands,
  // ===== DAEWOO ===== 19개
  ...daewooLampProducts,
];
